import { ICalculationItem } from 'components/calculation/CalculationContacts';

export const calcItemsKRV: ICalculationItem[][] = [
  [
    {
      title: 'ул. Молодой Гвардии, д.&nbsp;63',
      times: ['<b>08:00 — 19:00</b>, Пн-Пт', '<b>09:00 — 19:00</b>, Сб-Вс'],
    },
    {
      title: 'ул. Северо-Садовая, д.&nbsp;16А',
      times: ['<b>08:00 — 19:00</b>, Пн-Пт', '<b>09:00 — 19:00</b>, Сб-Вс'],
    },
  ],
];
